






























































































































import {Component, Prop, PropSync, Vue, Watch} from 'vue-property-decorator';
import { DxValidationGroup } from 'devextreme-vue';

import DButton from '@/components/DButton/button.vue';
import DTextbox from '@/components/DTextbox/textbox.vue';
import _ from 'lodash';
import DxPopup from 'devextreme-vue/popup';
import TableGrid from "@/components/TableGrid/grid.vue";
import AuthService from "@/services/auth_service";
import ShareService from "@/services/share-service";
import DictCacheService from "@/services/dicts_cache_service";
import ElementTabs from "@/components/ElTabs/tabs.vue";
import DxSelectBox from "devextreme-vue/select-box";
import {DxCheckBox} from "devextreme-vue/check-box";
import YearService from "@/services/years-service";
import CutService from "@/services/cut-service";
import AcceptLogService from "@/services/accept-log-service";
import EcoObjectsService from "@/services/eco-objects-service";
import dicts_cache_service from "@/services/dicts_cache_service";
import DxTagBox from "devextreme-vue/tag-box";
import {AcceptData, AcceptLogData, EcoObjectType} from "@/services/models-service";
import NotifyService from '@/services/notify_service'
import UserManagerService from "@/services/data/user_manager";
import UserRoleManagerService from "@/services/data/role_manager";
import UserAccessService from "@/services/user_access_service";
import DTagbox from "@/components/DTagbox/tagbox.vue";

@Component({
  name: 'AcceptLogBlock',
  components: {
    DTagbox,
    DxPopup,
    DxValidationGroup,
    DTextbox,
    DButton,
    TableGrid,
    ElementTabs,
    DxSelectBox,
    DxCheckBox,
    DxTagBox,
  }
})

export default class extends Vue {
  @PropSync('extAccept') public accept!: AcceptData;
  @Prop() public cut_ds!: any[];

  public service = AcceptLogService;
  public dictCacheService = DictCacheService;
  public shareService = ShareService;
  public authService = AuthService;
  public cutService = CutService;
  public ecoObjectsService = EcoObjectsService;
  public filter: any = [];
  public year_ds = YearService.YearList;
  public roles_ds = UserRoleManagerService.roles;
  public filial_ds: any = { data: [] };

  months: any = {
    january: 'янв',
    february: 'фев',
    march: 'мар',
    april: 'апр',
    may: 'май',
    june: 'июн',
    july: 'июл',
    august: 'авг',
    september: 'сен',
    october: 'окт',
    november: 'ноя',
    december: 'дек'
  }

  public columns: any[] = [];
  public checked_objects: any[] = [];
  public table_block_style: any = {
    width: '1000px',
    height: '500px',
  }
  public tableDrawReady: boolean = false;

  async created() {
    this.initColumns();
    this.service.data_loaded = false;
    this.service.filters_changed = true;


  }

  mounted() {
    this.tableDrawReady = false;

    setTimeout(()=> {
      let box = document.querySelector('.accept-log-content');
      let width = box?.clientWidth || 1000;
      let height = box?.clientHeight || 500;
      console.log(`${width} - ${height}`);

      this.table_block_style.width = `${width - 20}px`;
      this.table_block_style.height = `${height - 130}px`;
      this.tableDrawReady = true;
    }, 100);

    this.getFilials(true);
  }

  @Watch('accept.id_year')
  async watchYear(y1: any, y2: any) {

    this.service.filters_changed = true;
    this.accept.id_cut = null;

    this.resetChanges();
  }

  @Watch('accept.id_cut')
  async watchCut() {

    this.service.filters_changed = true;
    this.accept.id_filial = null;
    this.resetChanges();

    await this.getFilials(true);

  }

  @Watch('accept.id_filial')
  async watchFilial() {

    this.service.filters_changed = true;
    this.resetChanges();

  }

  async getFilials(force_update: boolean = false) {
    if (force_update) {
      this.filial_ds = { data: [] };
    }

    if (_.isNil(this.accept.id_year) || _.isNil(this.accept.id_cut)) {
      return
    }

    const year = this.year_ds.find((x) => {
      return x.id === this.accept.id_year
    })

    const cut = this.cut_ds.find((x: any) => {
      return x.id === this.accept.id_cut
    })

    if (!year || !cut) {
      return
    }

    try {
      const resp = await this.ecoObjectsService.get_filials(cut.id_eco_version, year.name, []);

      if (!resp?.data) {
        return
      }
      const current_user = UserManagerService.current_user;
      if (current_user?.eco_heat_nodes && current_user?.eco_heat_nodes.length > 0) {
        let filials_ids = new Set();
        for (let key in UserAccessService.userAccessDS) {
          filials_ids.add(+key)
        }
        const filteredFilials = resp.data.filter((f:EcoObjectType) => filials_ids.has(f.id));
        this.filial_ds.data = _.cloneDeep(filteredFilials);
      }
      else {
        this.filial_ds.data = _.cloneDeep(resp.data);
      }
    } catch (e) {
      
    }

  }


  @Watch('accept.all_filials')
  async watchAllFilials() {

    this.service.filters_changed = true;
    this.resetChanges();
  }

  resetChanges() {
    this.service.data_loaded = false;
  }

  initColumns() {

    const month_allow_filter = false;
    const month_allow_search = false;
    const month_width = '50px';

    this.columns = [{
      dataField: "id",
      dataType: "string",
      visible: false,
    },
    {
      dataField: "date_created",
      dataType: "date",
      caption: "Дата и время",
      sortOrder: 'desc',
    },
    {
      dataField: "blocks",
      dataType: "string",
      caption: "Параметры акцепта",
      allowSorting: false,
      calculateCellValue: this.calculateBlocks
    },
    {
      dataField: "user.full_name",
      dataType: "string",
      caption: "ФИО пользователя",
    },
      {
        dataField: "user.role",
        caption: "Роль пользователя",
        lookup: {
          dataSource: this.roles_ds,
          valueExpr: 'id',
          displayExpr: 'description'
        },
      },
    {
      dataField: "eco_filial_name",
      dataType: "string",
      caption: "Филиал",
      allowSorting: true,
      allowSearch: true,


    },
      {
        dataField: "id_eco_filial",
        visible: false
      },
    {
      dataField: "id_eco_heat_node",
      visible: false
    },
    {
      dataField: "eco_heat_node_name",
      dataType: "string",
      caption: "Теловой узел",
      allowSorting: true,
      allowSearch: true,

    },
    {
      dataField: "id_cut",
      dataType: "string",
      visible: false,
    },
    {
      dataField: "objects",
      dataType: "string",
      caption: "Объект",
      allowSorting: false,
      calculateCellValue: this.calculateObjects
    },
    ];

    let month_columns: any[] = [];
    for (let [index, value] of Object.keys(this.months).entries()) {

      month_columns.push({
        dataType: "boolean",
        caption: this.months[value],
        allowFiltering: month_allow_filter,
        allowSearch: month_allow_search,
        allowSorting: false,
        width: month_width,
        calculateCellValue: (e: any) => this.calculateMonth(e, index + 1)
      })
    }

    this.columns = this.columns.concat(month_columns);
  }

  public customizeCell(e: any) {


  }

  get readyForLoad() {
    return this.accept.id_year && this.accept.id_cut && (this.accept.id_filial?.length || this.accept.all_filials) && this.service.filters_changed;
  }

  async loadData() {

    this.service.data_loaded = false;
    this.$forceUpdate();



    let filter: any = [["id_cut", "=", this.accept.id_cut]];

    if (this.accept.all_filials) {
      let filials: any = this.filial_ds.data.map((filial: any) => {
        return filial.id
      })
      filter.push(["id_eco_filial", "in", filials])

    } else if (this.accept.id_filial && this.accept.id_filial.length > 0) {
      filter.push(["id_eco_filial", "in", this.accept.id_filial])
    }

    this.filter = _.cloneDeep(filter);
    this.service.filters_changed = false;

    this.service.data_loaded = true;

  }


  public refresh() {
    try {
      const grid = (this.$refs.logGrid as any).instance;
      grid.refresh();
    } catch (e) {
      
    }

  }

  get relative_cut() {
    let list = [];
    if (this.accept.id_year) {
      list = this.cut_ds.filter((c:any) => c.id_year === this.accept.id_year);
    }
    return list;
  }

  onClose() {
    this.shareService.closeAcceptPopup();
  }

  async onOk(e: any) {

  }



  calculateMonth(rowData: any, month_number: number): boolean {
    return rowData.months.list.indexOf(month_number) !== -1;
  }

  calculateBlocks(rowData: any): string {
    let res: string = "";
    if (rowData?.blocks?.list) {
      res = rowData?.blocks?.list.join('; ')
    }
    return res;
  }

  calculateObjects(rowData: any): string {
    let res: string = "";
    if (rowData?.objects?.list) {
      res = rowData?.objects?.list.join('; ')
    }
    return res;
  }

  empty() {

  }

}
